import type { ReactNode } from 'react'
import { Suspense } from 'react'
import { View } from 'react-native'
import * as Sentry from '@sentry/react-native'

import { ScreenLoadingFallback } from '../ui/ScreenLoadingFallback'
import { SentryErrorFallback } from '../ui/SentryErrorFallback'

interface AccountTabScreenBoundaryProps {
  children: ReactNode
}

export function AccountTabScreenBoundary({
  children,
}: AccountTabScreenBoundaryProps) {
  return (
    <View className="flex-1 bg-background-primary">
      <Sentry.ErrorBoundary
        fallback={(props) => (
          <SentryErrorFallback {...props} showReportIssueAction />
        )}
      >
        <Suspense fallback={<ScreenLoadingFallback />}>{children}</Suspense>
      </Sentry.ErrorBoundary>
    </View>
  )
}
